import { useEffect, useRef } from "react";

import { readStickySignupEmail } from "@/offering_v2/lib/sticky_promo_code";

// One-shot per mount: when the checkout form mounts with an empty email AND
// the discount popup recorded a signup earlier (same browser, within 30 days),
// copy that email into the form. A ref guards against re-prefilling if the
// user later clears the field — manual edits should not be fought.
//
// Storage is NOT cleared by this hook. Clearing is the redeem-flow's job
// (useClearStickyPromoOnRedeem), which wipes the whole signup record (code +
// email) atomically. Until then the email persists across page reloads /
// navigations within the 30-day window, mirroring the sticky promo code.
export function useRecentSignupEmailPrefill(
  currentEmail: string | undefined,
  setEmail: (email: string) => void
): void {
  const prefilledRef = useRef(false);

  useEffect(() => {
    if (prefilledRef.current) return;
    if (currentEmail) return;
    const email = readStickySignupEmail();
    if (!email) return;
    prefilledRef.current = true;
    setEmail(email);
    // setEmail is captured by reference; including it in deps would re-fire on
    // every parent render. The ref guard above provides the one-shot semantic.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentEmail]);
}
